module.exports = __webpack_public_path__ + "static/demo-screen-1-936df3a40300a91a4a067bd5d2f2dafc.jpg";